<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><i>To my mother</i></p>
<p class="center"><i>EMILY MORROW</i></p>
<p class="center"><i>for her love</i></p>
<p class="center"><i>and integrity</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4dedication.vue?5312a757